import React, { useState, useRef } from 'react';
import { fulfillmentChannel, regionalShare, eliteWarehouse, geographicalSales } from '../../../../services/geographicalSalesInsights';

const useGeographicalSalesInsights= () => {
  const [loading, setLoading] = useState(false);
  const [fulfillmentChannelState, setFulfillmentChannelState] = useState([]);
  const [regionalShareState, setRegionalShareState] = useState([]);
  const [eliteWarehouseState, setEliteWarehouseState] = useState([]);
  const [geographicalSalesState, setGeographicalSalesState] = useState([]);
  const [geographicalSalesSequence, setGeographicalSalesSequence] = useState([]);
  const [accessDenied, setAccessDenied] = useState(false);

  const debounceRef = useRef(null);

  const getGeographicalSales = async ({ formattedEnd , formattedStart ,selectedIds = []  }) =>{
    setLoading(true);
    try {
      let response = await geographicalSales({ formattedEnd , formattedStart, selectedIds });
      if (response && response.success && response.data) {
        setGeographicalSalesState(response.data);
        setGeographicalSalesSequence(response?.sequence)
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
      if (error.status === 403){
        setAccessDenied(true)
      }
    }
  }

  const getFulfillmentChannel = async ({ formattedEnd , formattedStart, selectedIds = [] }) =>{
    setLoading(true);
    try {
      let response = await fulfillmentChannel({ formattedEnd , formattedStart, selectedIds });
      if (response && response.success && response.data) {
        setFulfillmentChannelState(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const getRegionalShare = async ({ formattedEnd , formattedStart, selectedIds = [] }) =>{
    setLoading(true);
    try {
      let response = await regionalShare({ formattedEnd , formattedStart, selectedIds });
      if (response && response.success && response.data) {
        setRegionalShareState(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const getEliteWarehouse = async ({ formattedEnd , formattedStart, selectedIds = [] }) =>{
    setLoading(true);
    try {
      let response = await eliteWarehouse({ formattedEnd , formattedStart, selectedIds });
      if (response && response.success && response.data) {
        setEliteWarehouseState(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
    }
  }
    
  return {
    loading,
    fulfillmentChannelState,
    regionalShareState,
    eliteWarehouseState,
    geographicalSalesState,
    geographicalSalesSequence,

    getFulfillmentChannel,
    getRegionalShare,
    getEliteWarehouse,
    getGeographicalSales,
    accessDenied
  };
};

export default useGeographicalSalesInsights;
